"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function patch(t) {
  t.getType = function getType(val) {
    if (Array.isArray(val)) {
      return "array";
    } else if (val === null) {
      return "null";
    } else if (val === undefined) {
      return "undefined";
    } else {
      return typeof val;
    }
  };

  t.assertEach = function assertEach(callback) {
    function validator(node, key, val) {
      if (!Array.isArray(val)) return;

      for (var i = 0; i < val.length; i++) {
        callback(node, `${key}[${i}]`, val[i]);
      }
    }
    validator.each = callback;
    return validator;
  };

  t.assertOneOf = function assertOneOf() {
    for (var _len = arguments.length, vals = Array(_len), _key = 0; _key < _len; _key++) {
      vals[_key] = arguments[_key];
    }

    function validate(node, key, val) {
      if (vals.indexOf(val) < 0) {
        throw new TypeError(`Property ${key} expected value to be one of ${JSON.stringify(vals)} but got ${JSON.stringify(val)}`);
      }
    }

    validate.oneOf = vals;

    return validate;
  };

  t.assertNodeType = function assertNodeType() {
    for (var _len2 = arguments.length, types = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      types[_key2] = arguments[_key2];
    }

    function validate(node, key, val) {
      var valid = false;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = types[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var type = _step.value;

          if (t.is(type, val)) {
            valid = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!valid) {
        throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types)} ` + `but instead got ${JSON.stringify(val && val.type)}`);
      }
    }

    validate.oneOfNodeTypes = types;

    return validate;
  };

  t.assertNodeOrValueType = function assertNodeOrValueType() {
    for (var _len3 = arguments.length, types = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      types[_key3] = arguments[_key3];
    }

    function validate(node, key, val) {
      var valid = false;

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = types[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var type = _step2.value;

          if (t.getType(val) === type || t.is(type, val)) {
            valid = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (!valid) {
        throw new TypeError(`Property ${key} of ${node.type} expected node to be of a type ${JSON.stringify(types)} ` + `but instead got ${JSON.stringify(val && val.type)}`);
      }
    }

    validate.oneOfNodeOrValueTypes = types;

    return validate;
  };

  t.assertValueType = function assertValueType(type) {
    function validate(node, key, val) {
      var valid = t.getType(val) === type;

      if (!valid) {
        throw new TypeError(`Property ${key} expected type of ${type} but got ${t.getType(val)}`);
      }
    }

    validate.type = type;

    return validate;
  };

  t.chain = function chain() {
    for (var _len4 = arguments.length, fns = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      fns[_key4] = arguments[_key4];
    }

    function validate() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = fns[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var fn = _step3.value;

          fn.apply(undefined, arguments);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
    validate.chainOf = fns;
    return validate;
  };

  t.hasType = function hasType(type) {
    return t.TYPES.indexOf(type) > -1;
  };

  t.definePluginType = function definePluginType(type) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // No duplicate reg
    if (t.TYPES.indexOf(type) > -1) return;

    var inherits = {};
    if (opts.inherits) {
      inherits.visitor = t.VISITOR_KEYS[opts.inherits];
      inherits.builder = t.BUILDER_KEYS[opts.inherits];
      inherits.fields = t.NODE_FIELDS[opts.inherits];
      inherits.aliases = t.ALIAS_KEYS[opts.inherits];
    }

    opts.fields = opts.fields || inherits.fields || {};
    opts.visitor = opts.visitor || inherits.visitor || [];
    opts.aliases = opts.aliases || inherits.aliases || [];
    opts.builder = opts.builder || inherits.builder || opts.visitor || [];

    if (opts.deprecatedAlias) {
      t.DEPRECATED_KEYS[opts.deprecatedAlias] = type;
    }

    // ensure all field keys are represented in `fields`
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = opts.visitor.concat(opts.builder)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var key = _step4.value;

        opts.fields[key] = opts.fields[key] || {};
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    for (var _key5 in opts.fields) {
      var field = opts.fields[_key5];

      if (opts.builder.indexOf(_key5) === -1) {
        field.optional = true;
      }
      if (field.default === undefined) {
        field.default = null;
      } else if (!field.validate) {
        field.validate = t.assertValueType(t.getType(field.default));
      }
    }

    t.VISITOR_KEYS[type] = opts.visitor;
    t.BUILDER_KEYS[type] = opts.builder;
    t.NODE_FIELDS[type] = opts.fields;
    t.ALIAS_KEYS[type] = opts.aliases;

    // the below should not be necessary; see https://github.com/babel/babel/pull/4886
    t.TYPES.push(type);

    return opts.aliases.forEach(function (alias) {
      t.FLIPPED_ALIAS_KEYS[alias] = t.FLIPPED_ALIAS_KEYS[alias] || [alias];
      t.FLIPPED_ALIAS_KEYS[alias].push(type);

      if (!t.TYPES[alias]) return t.TYPES.push(alias);
    });
  };

  return t;
};

module.exports = exports["default"];